import React from "react";
import { NavLink } from "react-router-dom";

const logos = [
  { image: require("./../../images/client-logo/logo1.png") },
  { image: require("./../../images/client-logo/logo2.png") },
  { image: require("./../../images/client-logo/logo3.png") },
  { image: require("./../../images/client-logo/logo4.png") },
  { image: require("./../../images/client-logo/logo5.png") },
  { image: require("./../../images/client-logo/logo6.png") },
  { image: require("./../../images/client-logo/logo7.png") },
  { image: require("./../../images/client-logo/logo8.png") },
];
const clientsName = [
  { name: "SMT Promoters" },
  { name: "Anand Promoters" },
  { name: "Dhrona Promoter" },
  { name: "Vaitheswaran Construction" },
  { name: "Thai Promoters" },
  { name: "Abi Constructions " },
  { name: "Jayabharath Developers" },
  { name: "Veeramani Electricals" },
  { name: "Sr Construction" },
  { name: "Bright Builders and Developers" },
  { name: "Shana Promoters" },
  { name: "TVH Apartments" },
];

var bgimg1 = require("./../../images/background/bg-12.jpg");
var bgimg2 = require("./../../images/background/cross-line2.png");

class ClientsLogo1 extends React.Component {
  render() {
    return (
      <>
        <div
          className="section-full  mobile-page-padding bg-gray  p-t80 p-b10 bg-repeat"
          style={{ backgroundImage: "url(" + bgimg1 + ")" }}
        >
          <div className="container">
            {/* TITLE START */}
            <div className="section-head">
              <div className="sx-separator-outer separator-left">
                <div
                  className="sx-separator bg-white bg-moving bg-repeat-x"
                  style={{ backgroundImage: "url(" + bgimg2 + ")" }}
                >
                  <h3 className="sep-line-one">Our Clients</h3>
                </div>
              </div>
            </div>
            {/* TITLE END */}
            <div className="section-content">
              <div className="client-grid m-b40">
                <div className="row justify-content-center">
                  {clientsName.map((item, index) => (
                    <div
                      className="col-lg-3 col-md-4 col-sm-6 col-6 m-b30"
                      key={index}
                    >
                      <NavLink
                        to="javascript:void(0)"
                        className="client-logo-pic"
                      >
                        {/* <img src={item.image} alt="" />
                        <div>
                          <span>View More</span>
                        </div> */}
                        <h2 className="clientH2">{item.name}</h2>
                      </NavLink>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="hilite-title text-left p-l50 text-uppercase">
            <strong>Clients</strong>
          </div>
        </div>
      </>
    );
  }
}

export default ClientsLogo1;
